app.factory("Insurance", [
	"MEDICAL_INSURANCE",
	function (MEDICAL_INSURANCE) {
		// Explicit "the patient pays out of their own pocket" marker. It is an ordinary member of
		// the list and may sit beside any provider, because holding cover does not stop a patient
		// choosing to self-fund a given procedure:
		//   []                        nobody has recorded an answer yet  ->  "No insurance set"
		//   ["NO_INSURANCE"]          asked, holds none, self-pays
		//   ["NIB", ...]              holds cover
		//   ["NO_INSURANCE", "NIB"]   holds cover but may still pay for a procedure themselves
		//
		// Only an explicit user selection may produce the marker. Nothing in here may invent it,
		// or "not asked" silently becomes an answer nobody gave.
		var NONE = "NO_INSURANCE";

		// Publicly funded care. A provider like any other since it can sit alongside private cover.
		var PUBLIC = "PUBLIC";

		// The providers actually chosen, without the explicit "none" marker.
		function selected(patient) {
			var providers = (patient && patient.insuranceProviders) || [];
			return providers.filter(function (value) {
				return value !== NONE;
			});
		}

		return {
			NONE: NONE,
			PUBLIC: PUBLIC,

			selected: selected,

			// True if the patient has any insurance. Public funding is one of the providers,
			// so it counts here like any other.
			hasAny: function (patient) {
				if (!patient) {
					return false;
				}
				return selected(patient).length > 0;
			},

			// True once somebody has recorded an answer, whether that answer is cover or
			// "none, self-paid". This - not hasAny - is what "do we still need to ask?" means.
			isAnswered: function (patient) {
				return !!patient
					&& !!patient.insuranceProviders
					&& patient.insuranceProviders.length > 0;
			},

			// True when self-paying is the whole answer and the patient holds nothing else.
			// Deliberately strict: a self-payer who also holds cover could be billed either way,
			// so callers deciding who pays must not treat that patient as settled.
			isSelfPaid: function (patient) {
				return !!patient
					&& !!patient.insuranceProviders
					&& patient.insuranceProviders.length === 1
					&& patient.insuranceProviders[0] === NONE;
			},

			// True if the patient has this insurance provider, for example "SOUTHERN_CROSS".
			has: function (patient, value) {
				return !!patient
					&& !!patient.insuranceProviders
					&& patient.insuranceProviders.indexOf(value) !== -1;
			},

			// Display name for a provider value. `otherName` is the free-text insurer
			// name and is only used for OTHER. Returns null for anything not on the list.
			providerName: function (value, otherName) {
				if (value === "OTHER") {
					return otherName ? ("Other (" + otherName + ")") : "Other";
				}
				var option = MEDICAL_INSURANCE.find(function (t) {
					return t.value === value;
				});
				return option ? option.name : null;
			},

			// The providers offered as the payer for a single operation. What the patient
			// already holds, when they hold anything - otherwise nothing is known about who
			// pays, so the whole list is offered. Public and the explicit "none" always sit
			// at the end, because either can be true of a patient whose record says nothing.
			payerOptions: function (patient) {
				var chosen = selected(patient).filter(function (value) {
					return value !== PUBLIC;
				});
				var base = chosen.length
					? MEDICAL_INSURANCE.filter(function (option) {
						return chosen.indexOf(option.value) !== -1;
					})
					: MEDICAL_INSURANCE.filter(function (option) {
						// Both are appended below with payer-specific wording, so drop them here
						// rather than offering either of them twice.
						return option.value !== PUBLIC && option.value !== NONE;
					});

				return base.concat([
					{ value: PUBLIC, name: "Public" },
					{ value: NONE, name: "No insurance / self-paid" },
				]);
			},
		};
	},
]);
